var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar30(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-25",
    "data-name": "50_Kids_Icons-25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M80,40A40,40,0,1,1,40,0,40,40,0,0,1,80,40Z",
    fill: "#43b06d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4456",
    "data-name": "Group 4456",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M172.188,140.534H130V103.816a21.094,21.094,0,0,1,21.094-21.094h0a21.094,21.094,0,0,1,21.094,21.094Z",
    transform: "translate(-109.688 -69.797)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446",
    transform: "translate(23.917 37.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M159.79,243.329c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S158.765,240.9,159.79,243.329Z",
    transform: "translate(-153.072 -239.721)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M326.844,243.329c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S327.869,240.9,326.844,243.329Z",
    transform: "translate(-299.259 -239.721)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 17.969,
    cy: 16.449,
    rx: 17.969,
    ry: 16.449,
    transform: "translate(23.1 12.991)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M135.242,409.1l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.632,20.632,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.172 -324.296)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M233.822,273.845a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V257.827a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-186.157 -212.294)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4448",
    "data-name": "Group 4448",
    transform: "translate(28.125 17.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4447",
    "data-name": "Group 4447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M206.766,137.237a13.383,13.383,0,0,1-13.383,13.383h0A13.383,13.383,0,0,1,180,137.238V126.105a13.383,13.383,0,0,1,13.383-13.383h0a13.384,13.384,0,0,1,13.384,13.384v11.132Z",
    transform: "translate(-179.999 -112.722)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4449",
    "data-name": "Group 4449",
    transform: "translate(34.39 40.997)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    fill: "#572020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(10.263)",
    fill: "#572020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4450",
    "data-name": "Group 4450",
    transform: "translate(25.358 15.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M178,98.914c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l.787-6.674a7.435,7.435,0,0,1,7.383-6.564h10.818a7.435,7.435,0,0,1,7.384,6.563l.789,6.676a18.052,18.052,0,0,0,2.13-8.566C193.716,106.538,186.682,98.914,178,98.914Z",
    transform: "translate(-162.294 -98.914)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M251.273,276.379a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,251.273,276.379Z",
    transform: "translate(-207.989 -233.195)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M135.233,421.9c0-8-2.995-15.752-6.652-17.229L116.2,399.686a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.172 -337.235)",
    fill: "#ffc34a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4451",
    "data-name": "Group 4451",
    transform: "translate(35.312 48.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M234.749,313.089a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.163-.625-3.015-1.856-1.856Z",
    transform: "translate(-225.999 -312.722)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4455",
    "data-name": "Group 4455",
    transform: "translate(27.716 37.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4454",
    "data-name": "Group 4454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    "data-name": "Group 4452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M187.035,249.817H180.06a2.679,2.679,0,0,1-2.676-2.676v-3.016a2.68,2.68,0,0,1,2.676-2.676h6.974a2.679,2.679,0,0,1,2.676,2.676v3.016A2.679,2.679,0,0,1,187.035,249.817Zm-6.974-7.163a1.472,1.472,0,0,0-1.47,1.47v3.016a1.472,1.472,0,0,0,1.47,1.47h6.974a1.472,1.472,0,0,0,1.471-1.47v-3.016a1.472,1.472,0,0,0-1.471-1.47Z",
    transform: "translate(-177.384 -241.448)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4453",
    "data-name": "Group 4453",
    transform: "translate(14.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M282.337,249.817h-6.974a2.679,2.679,0,0,1-2.676-2.676v-3.016a2.68,2.68,0,0,1,2.676-2.676h6.974a2.679,2.679,0,0,1,2.676,2.676v3.016A2.68,2.68,0,0,1,282.337,249.817Zm-6.974-7.163a1.472,1.472,0,0,0-1.47,1.47v3.016a1.472,1.472,0,0,0,1.47,1.47h6.974a1.472,1.472,0,0,0,1.47-1.47v-3.016a1.472,1.472,0,0,0-1.47-1.47Z",
    transform: "translate(-272.686 -241.448)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1160",
    "data-name": "Rectangle 1160",
    width: 3.618,
    height: 1.378,
    transform: "translate(11.8 3.632)",
    fill: "#3d2a3d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar30);
export default __webpack_public_path__ + "static/media/avatar30.983f0f9bd2969c65fd7f38e57731da6d.svg";
export { ForwardRef as ReactComponent };